import classNames from 'classnames';
import { SortOrder } from '@Comments/models/SortOrder';
import { useAppContext, useAppDispatcher } from '@Comments/context/AppContext';

import './Tabs.scss';

export const Tabs = () => {
  const { sortOrder, commentsCount, thread } = useAppContext();
  const dispatch = useAppDispatcher();

  const tabs = [];
  if (
    commentsCount > 0 ||
    thread.welcomeMessage !== '' ||
    thread.goodbyeMessage !== ''
  ) {
    tabs.push({
      sortOrder: 'created',
      description: 'Alle Kommentare',
    });
  }

  if (commentsCount > 3) {
    tabs.push({
      sortOrder: 'popular',
      description: 'Beliebteste',
    });
  }

  const handleTabChange = (sortOrder: SortOrder) => {
    dispatch({ type: 'update-sort-order', data: sortOrder });
  };

  return (
    <>
      {tabs.length > 0 && (
        <div className="srf-comments-tabs-container">
          <ul className="srf-comments-tabs" role="tablist">
            {tabs.map((tab) => {
              return (
                <li
                  key={tab.sortOrder}
                  className="srf-comments-tab-option"
                  role="presentation">
                  <button
                    type="button"
                    className={classNames('srf-comments-tab-option__button', {
                      'srf-comments-tab-option__button--selected':
                        sortOrder === tab.sortOrder,
                    })}
                    role="tab"
                    onClick={() => {
                      handleTabChange(tab.sortOrder as SortOrder);
                    }}>
                    {tab.description}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};
